<template>
  <div :class="containerClass" class="Popup">
    <div class="background" @click="$emit('close')"></div>
    <div :style="containerStyle" class="popup">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Popup',
  props: {
    enabled: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: '800px',
    },
    height: {
      type: String,
      default: 'unset',
    },
    minWidth: {
      type: String,
      default: 'unset',
    },
    minHeight: {
      type: String,
      default: 'unset',
    },
  },

  computed: {
    containerClass () {
      return {
        enabled: this.enabled,
      }
    },

    containerStyle () {
      return {
        width: this.width,
        height: this.height,
        minWidth: this.minWidth,
        minHeight: this.minHeight,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.Popup {
  z-index: 50;

  &:not(.enabled) {
    pointer-events: none;

    .background {
      opacity: 0;
    }

    .popup {
      display: none;
    }
  }

  .background {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 1;
    background-color: rgb(0, 0, 0, 0.7);
    transition: 0.1s ease-out background-color;
  }

  pointer-events: unset;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 66px;

  .popup {
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: calc(100% - 40px);
    max-height: calc(100vh - 160px);
    padding: 20px;
    overflow-y: auto;

    background-color: black;
    border: 1px solid white;
  }

  @media only screen and (max-width: $phone-max-width) {
    .popup {
      max-width: 100%;
      max-height: calc(100vh - 66px);
    }
  }
}
</style>
